import React from 'react'

export const UserContext = React.createContext({
  role: null,
  currentUser: {},
  changeRole: () => { },
})